import React from 'react'
import { Card } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const CaptableManagementQuickActionsSkeleton = () => {
    return (
        <Card className='w-100 p-4 bg-white'>
            <div>
                {/* <p className='text-muted'>{formatMessage({ id: title })}</p> */}
                <Skeleton
                    width={120}
                    height={20}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    className='mb-2'
                />
                <div>
                    {/* <NoDataPage /> */}
                    <Skeleton
                        width={'100%'}
                        height={320}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        className='mb-2'
                    />
                </div>
            </div>
        </Card>
    )
}

export default CaptableManagementQuickActionsSkeleton
